import React from "react";

const defaultSize = 18;

/**
 * Carecentre Zen editorial stroke icons (18×18, 1.5px stroke).
 * Use inside CcButton / CcIconButton via startIcon or as children.
 */
export const CcIconDocument = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M10.5 2.5H4.75A1.25 1.25 0 003.5 3.75v10.5A1.25 1.25 0 004.75 15.5h8.5a1.25 1.25 0 001.25-1.25V6.5L10.5 2.5z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 2.5V6.5h4M6.25 9.25h5.5M6.25 11.75h3.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

/** Document with pencil — care plan “view document” toolbar icon. */
export const CcIconDocumentEdit = ({
  size = defaultSize,
  className,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M10.5 2.5H4.75A1.25 1.25 0 003.5 3.75v10.5A1.25 1.25 0 004.75 15.5h8.5a1.25 1.25 0 001.25-1.25V6.5L10.5 2.5z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 2.5V6.5h4M6.25 9.25h5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.75 11.25l2.5 2.5M12.875 10.125l1.375 1.375"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CcIconDocumentAdd = ({
  size = defaultSize,
  className,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M10 2.5H4.75A1.25 1.25 0 003.5 3.75v10.5A1.25 1.25 0 004.75 15.5h8.5a1.25 1.25 0 001.25-1.25V6.25L10 2.5z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M10 2.5V6.25H13.75M6 9.25h6M6 11.75h4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M13.25 2.25v2.5M11.75 3.75h3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CcIconArchive = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M3.25 4.25h11.5M4.75 4.25V3.5a1 1 0 011-1h6.5a1 1 0 011 1v.75M5.5 8.25h7M6.75 11.25h4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.75 4.25l.75 9a1 1 0 001 .875h5a1 1 0 001-.875l.75-9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9 8.25v3.25M7.375 10.875L9 12.5l1.625-1.625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CcIconEdit = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M11.25 3.75l3 3-7.5 7.5H3.75v-3l7.5-7.5z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 5.25l3 3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CcIconPlay = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M6.75 4.75v8.5l6.75-4.25-6.75-4.25z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const CcIconBook = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M4.25 3.75h4.25a1.5 1.5 0 011.5 1.5V14a2.25 2.25 0 00-2.25-2.25H4.25V3.75zM13.75 3.75H9.5a1.5 1.5 0 00-1.5 1.5V14a2.25 2.25 0 012.25-2.25h3.5V3.75z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const CcIconCheck = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <circle cx="9" cy="9" r="7.25" fill="currentColor" />
    <path
      d="M5.75 9.25l2 2 4.5-4.75"
      stroke="#fff"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CcIconTrash = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M4 5.5h10M7.25 5.5V4.25a1 1 0 011-1h1.5a1 1 0 011 1V5.5M6.25 8v5.75M9 8v5.75M11.75 8v5.75M5.5 5.5l.5 9a1 1 0 001 .875h4a1 1 0 001-.875l.5-9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CcIconSave = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M12.75 15.25H5.25A1.25 1.25 0 004 14V4.75A1.25 1.25 0 005.25 3.5h5.25L14 7v7.25a1.25 1.25 0 01-1.25 1.25z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 3.5V7.25H14M6.5 10.25h5M6.5 12.75h3.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CcIconBulb = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M9 2.25a4.25 4.25 0 00-2.45 7.72V11.5a1 1 0 001 1h2.9a1 1 0 001-1V9.97A4.25 4.25 0 009 2.25z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 14.25h3M8.25 16.25h1.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CcIconSearch = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <circle cx="8" cy="8" r="4.75" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M11.5 11.5L15.25 15.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CcIconPlus = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M9 4.25v9.5M4.25 9h9.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CcIconClose = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M5.25 5.25l7.5 7.5M12.75 5.25l-7.5 7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

/** Empty / null state — circle with diagonal stroke. */
export const CcIconEmpty = ({ size = 24, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M7.5 7.5l9 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CcIconMore = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <circle cx="4.5" cy="9" r="1.25" fill="currentColor" />
    <circle cx="9" cy="9" r="1.25" fill="currentColor" />
    <circle cx="13.5" cy="9" r="1.25" fill="currentColor" />
  </svg>
);

export const CcIconHome = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M3.25 7.75 9 3.25l5.75 4.5V14a1 1 0 01-1 1H4.25a1 1 0 01-1-1V7.75z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7.25 14.25V10a1 1 0 011-1h1.5a1 1 0 011 1v4.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

/** Bar chart — care round report / analytics actions. */
export const CcIconReport = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M3.25 14.25V10.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M6.75 14.25V6.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10.25 14.25V8.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M13.75 14.25V11.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.75 14.75h12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CcIconDownload = ({ size = defaultSize, className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M9 3.25v7.5M6.25 10.25 9 13l2.75-2.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25 14.75h9.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CcIconChevronLeft = ({
  size = defaultSize,
  className,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M11.25 4.25 6.5 9l4.75 4.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CcIconChevronRight = ({
  size = defaultSize,
  className,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    className={className}
    aria-hidden
    {...props}
  >
    <path
      d="M6.75 4.25 11.5 9l-4.75 4.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Wraps a Carecentre icon for MUI Button startIcon slots. */
export const CcButtonIcon = ({ children }) => (
  <span className="cc-button-icon">{children}</span>
);
